import { TrialIds } from 'purchase-motions-components/constants/trial';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
export let TrialId;
(function (TrialId) {
  TrialId[TrialId["SalesEnterprise"] = TrialIds.SALES_ENTERPRISE] = "SalesEnterprise";
  TrialId[TrialId["SalesProfessional"] = TrialIds.SALES_PROFESSIONAL] = "SalesProfessional";
  TrialId[TrialId["MarketingEnterprise"] = TrialIds.MARKETING_ENTERPRISE] = "MarketingEnterprise";
  TrialId[TrialId["MarketingProfessional"] = TrialIds.MARKETING_PRO] = "MarketingProfessional";
  TrialId[TrialId["ServiceEnterprise"] = TrialIds.SERVICE_ENTERPRISE] = "ServiceEnterprise";
  TrialId[TrialId["ServiceProfessional"] = TrialIds.SERVICE_PROFESSIONAL] = "ServiceProfessional";
  TrialId[TrialId["CmsEnterprise"] = TrialIds.CMS_ENTERPRISE] = "CmsEnterprise";
  TrialId[TrialId["CmsProfessional"] = TrialIds.CMS_PROFESSIONAL] = "CmsProfessional";
  TrialId[TrialId["OperationsEnterprise"] = TrialIds.OPERATIONS_ENTERPRISE] = "OperationsEnterprise";
  TrialId[TrialId["OperationsProfessional"] = TrialIds.OPERATIONS_PROFESSIONAL] = "OperationsProfessional";
  TrialId[TrialId["CrmSuiteStarterBundle"] = TrialIds.CRM_SUITE_STARTER_BUNDLE] = "CrmSuiteStarterBundle";
  TrialId[TrialId["AeoStandalone"] = TrialIds.AEO_STANDALONE] = "AeoStandalone";
})(TrialId || (TrialId = {}));
export const trialIdToTrialNames = {
  [TrialId.SalesEnterprise]: 'Sales Hub Enterprise',
  [TrialId.SalesProfessional]: 'Sales Hub Professional',
  [TrialId.MarketingEnterprise]: 'Marketing Hub Enterprise',
  [TrialId.MarketingProfessional]: 'Marketing Hub Professional',
  [TrialId.ServiceEnterprise]: 'Service Hub Enterprise',
  [TrialId.ServiceProfessional]: 'Service Hub Professional',
  [TrialId.CmsEnterprise]: 'CMS Hub Enterprise',
  [TrialId.CmsProfessional]: 'CMS Hub Professional',
  [TrialId.OperationsEnterprise]: 'Operations Hub Enterprise',
  [TrialId.OperationsProfessional]: 'Operations Hub Professional',
  [TrialId.CrmSuiteStarterBundle]: 'Starter Customer Platform',
  [TrialId.AeoStandalone]: 'AEO Standalone',
  [100]: 'test-trial'
};
export const TrialToHubInterestOption = new Map([[TrialId.SalesEnterprise, HubInterestOption.Sales], [TrialId.SalesProfessional, HubInterestOption.Sales], [TrialId.MarketingEnterprise, HubInterestOption.Marketing], [TrialId.MarketingProfessional, HubInterestOption.Marketing], [TrialId.ServiceEnterprise, HubInterestOption.CustomerService], [TrialId.ServiceProfessional, HubInterestOption.CustomerService], [TrialId.OperationsEnterprise, HubInterestOption.Operations], [TrialId.OperationsProfessional, HubInterestOption.Operations], [TrialId.CmsEnterprise, HubInterestOption.CMS], [TrialId.CmsProfessional, HubInterestOption.CMS], [TrialId.CrmSuiteStarterBundle, HubInterestOption.Sales]]);
export let ProTrialName;
(function (ProTrialName) {
  ProTrialName["MarketingProfessional"] = "MARKETING_PROFESSIONAL";
  ProTrialName["SalesProfessional"] = "SALES_PROFESSIONAL";
  ProTrialName["ServiceProfessional"] = "SERVICE_PROFESSIONAL";
  ProTrialName["CmsProfessional"] = "CMS_PROFESSIONAL";
  ProTrialName["OperationsProfessional"] = "OPERATIONS_PROFESSIONAL";
})(ProTrialName || (ProTrialName = {}));
export const TrialConfigByName = {
  [ProTrialName.SalesProfessional]: {
    illustrationKey: 'sales-professional',
    trialId: TrialId.SalesProfessional
  },
  [ProTrialName.MarketingProfessional]: {
    illustrationKey: 'marketing-pro',
    trialId: TrialId.MarketingProfessional
  },
  [ProTrialName.ServiceProfessional]: {
    illustrationKey: 'service-hub-professional',
    trialId: TrialId.ServiceProfessional
  },
  [ProTrialName.OperationsProfessional]: {
    illustrationKey: 'operations-custom-mappings',
    trialId: TrialId.OperationsProfessional
  },
  [ProTrialName.CmsProfessional]: {
    illustrationKey: 'add-on-website',
    trialId: TrialId.CmsProfessional
  }
};